/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ChangeDetectionStrategy, Component, signal} from '@angular/core';
import {type ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SearchListComponent} from '@dv/kitadmin/search';
import {FunctionType, SearchResultEntry} from '@dv/shared/code';
import {TranslocoDirective} from '@jsverse/transloco';

export interface KinderOrteSelectionModel {
    alleKinderOrte: boolean;
    kinderOrte: SearchResultEntry[];
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'dv-kinder-orte-selection',
    imports: [
        FormsModule,
        TranslocoDirective,
        SearchListComponent,
    ],
    templateUrl: './kinder-orte-selection.component.html',
    styles: ':host { display: block; }',
    providers: [
        {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: KinderOrteSelectionComponent},
    ],
})
export class KinderOrteSelectionComponent implements ControlValueAccessor {

    public alleKinderOrte = true;
    public kinderOrte: SearchResultEntry[] = [];

    public onChange?: (selection?: KinderOrteSelectionModel) => unknown;
    public onTouched?: FunctionType;
    public isDisabled = signal(false);

    public selectionChanged(): void {
        this.onChange?.({
            alleKinderOrte: this.alleKinderOrte,
            kinderOrte: this.alleKinderOrte ? [] : this.kinderOrte,
        });
    }

    public registerOnChange(fn: FunctionType): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: FunctionType): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.isDisabled.set(isDisabled);
    }

    public writeValue(selection: KinderOrteSelectionModel): void {
        this.alleKinderOrte = selection?.alleKinderOrte ?? true;
        this.kinderOrte = selection?.kinderOrte ?? [];
    }
}
